import { COLOR_GRAY_900, COLOR_WHITE } from '../../config/constants';

// eslint-disable-next-line import/prefer-default-export
export const POPOVER_COLORS = [
  COLOR_GRAY_900,
  COLOR_WHITE,
];
